import { InfinitySpin, ColorRing } from  'react-loader-spinner'
import { useTheme } from '@mui/material/styles';
function Loading({style, height, width}) {
  const theme = useTheme()
  return (
        // <div style={{display:'flex', justifyContent:'center', alignItems:'center', ...style}}>
        //   <ColorRing
        //     visible={true}
        //     height={height}
        //     width={width}
        //     ariaLabel="blocks-loading"
        //     wrapperStyle={{}}
        //     wrapperClass="blocks-wrapper"
        //     colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
        //   />
        // </div>
        <div className='skeleton' style={{height:height, width:width,...style}}>

        </div>
  )
}

export default Loading